import React, { useState, useRef } from 'react'
import PrintLayout from '../components/print'
import { IntlProvider } from 'react-intl' /* react-intl imports */
import ZH_CN from '../locale/zh_CN'
import EN_US from '../locale/en_US'
import OrderPrintA4 from '../components/print/OrderPrintA4'
import OrderHtml from '../components/print/'
import { OrderDetailResTypes, OrderItemsTypes } from '../models/order/orderDetail'
import { orderDetail } from '../api/response'
import styled from 'styled-components'
import { useParams } from "react-router-dom-v5-compat";
import { useQuery } from '@tanstack/react-query';
import { PDFViewer } from '@react-pdf/renderer';

const PrintStyle = styled.div`
  @page {
    margin: 10mm 10mm;
  }
`
const order = (orderId): Promise<OrderDetailResTypes> =>
  orderDetail(orderId).then((res) => { if (res.success) return res.data; else throw new Error(res.message) })

const Print = (props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const params = useParams()
  const { isSuccess, error, data } = useQuery({
    queryKey: ['orderId', params.id],
    queryFn: () => order(params.id),
  })
  const messages = {
    'en-NZ': EN_US,
    'zh-CN': ZH_CN
  }
  return (
    <PrintStyle>
      {data && isSuccess ?
        <div>
          <IntlProvider locale={data.lang} messages={messages[data.lang]} >
            {/* <PDFViewer width="100%" height="1000">
              <OrderPrintA4 lang={data.lang} order={data} />
            </PDFViewer> */}
            <PrintLayout id={params.id} lang={data.lang} order={data} />
            {/* <OrderHtml lang={data.lang} order={data} id={params.id} /> */}
          </IntlProvider>
        </div>
        : <div>Loading...</div>}
    </PrintStyle>
  )
}

export default Print
